import { Component, OnInit, ViewChild, ElementRef, Input, ViewChildren, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';

import { StateService, AuthService, CountryService, RegionService, VarietyService, WineryService, WineService, AuctionService, UnitOfMeasureService, AttributeDefinitionService, WineCategoryService, AuctionLotService, CustomFilterService } from '../../../services';
import { CustomFilterModel, FilterItemValue, WineCategoryModel, WineryModel, CountryModel, RegionModel, WineModel, VarietyModel } from '../../../models';
import { FormFunctions } from '../../../functions';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalCreateCustomFilterComponent } from '../../modals';
import { AuctionCreateCustomFilterModel } from '../../models'

import { AuctionLotSearchFilterItemChoicesModel, AuctionLotSearchFilterItemRangeModel, AuctionLotSearchFilterItemTextModel } from '../../models';
import { AuctionLotSearchFilters } from 'src/app/models/auction-lot-search-filters.model';

@Component({
    selector: 'auction-search-filter',
    styleUrls: ['./auction-search-filter.component.scss'],
    templateUrl: './auction-search-filter.component.html',
})
export class AuctionSearchFilterComponent implements OnInit {
    processing: boolean = false;
    searching: boolean = false;
    IsFilterOpen: boolean = false;

    @Input() filters: AuctionLotSearchFilters;
    @Input() model: AuctionCreateCustomFilterModel;

    allWineries: WineryModel[] = [];
    allCategories: WineCategoryModel[] = [];
    allCountries: CountryModel[] = [];
    allRegions: RegionModel[] = [];
    allWines: WineModel[] = [];
    allVarieties: VarietyModel[] = [];

    customFilters: CustomFilterModel[] = [];
    firstSelected: string = "";

    @Output() updated = new EventEmitter();
    @Output() cleared = new EventEmitter();

    constructor(
        public router: Router,
        private activatedRoute: ActivatedRoute,
        public stateService: StateService,
        private modalService: NgbModal,
        public authService: AuthService,
        public formFunctions: FormFunctions,
        private attributeDefinitionService: AttributeDefinitionService,
        private countryService: CountryService,
        private regionService: RegionService,
        private unitOfMeasureService: UnitOfMeasureService,
        private varietyService: VarietyService,
        private wineCategoryService: WineCategoryService,
        private wineryService: WineryService,
        public auctionService: AuctionService,
        public auctionLotService: AuctionLotService,
        public customFilterService: CustomFilterService,
        public wineService: WineService
    ) {
        var me = this;
    }

    ngOnInit() {
        var me = this;

        me.customFilterService.FindAll().subscribe(data => {
            // console.log('GetCustomFilters', data);
            me.customFilters = data;
        });

        me.auctionLotService.auctionIdTrigger$.subscribe(data => {
            me.LoadData();
        });
    }

    LoadData() {
        let me = this;
        if (!me.auctionLotService.auctionId) return; // ignore blank auctions
        me.processing = true;
        me.stateService.loginKeepAlive();
        // console.log('LoadData', me.auctionLotService.auctionId);

        forkJoin([
            me.countryService.FindAll(me.auctionLotService.auctionId),
            me.regionService.FindAll(me.auctionLotService.auctionId),
            me.varietyService.FindAll(me.auctionLotService.auctionId),
            me.wineryService.FindAll(me.auctionLotService.auctionId),
            me.attributeDefinitionService.FindAll(null),
            me.unitOfMeasureService.FindAll(me.auctionLotService.auctionId),
            me.wineCategoryService.FindAll(me.auctionLotService.auctionId),
            me.auctionLotService.FindVintages(me.auctionLotService.auctionId),
            me.wineService.FindAll(me.auctionLotService.auctionId)
        ]).subscribe(([data1, data2, data3, data4, data5, data6, data7, data8, data9]) => {
            me.allCountries = data1;
            me.allRegions = data2;
            me.allVarieties = data3;
            me.allWineries = data4;
            me.allCategories = data7;
            me.allWines = data9;

            me.filters.country.options = data1.map(x => <FilterItemValue>{ value: x.Id, label: x.Name }).sort((a, b) => a.label > b.label ? 1 : -1);
            me.filters.region.options = data2.map(x => <FilterItemValue>{ value: x.Id, group: x.Country.Name, label: x.Name, data: x.Country?.Id }).sort((a, b) => a.group.localeCompare(b.group) || a.label.localeCompare(b.label));
            me.filters.variety.options = data3.map(x => <FilterItemValue>{ value: x.Id, label: x.Name }).sort((a, b) => a.label > b.label ? 1 : -1);
            me.filters.winery.options = data4.map(x => <FilterItemValue>{ value: x.Id, label: x.Name, data: x.RegionId }).sort((a, b) => a.label > b.label ? 1 : -1);
            me.filters.excludeAttribute.options = data5.sort((a, b) => a.Sequence > b.Sequence ? 1 : -1).map(x => <FilterItemValue>{ value: x.Id, label: x.Title });
            me.filters.unitOfMeasure.options = data6.map(x => <FilterItemValue>{ value: x.Id, label: x.Name }).sort((a, b) => a.label > b.label ? 1 : -1);
            me.filters.category.options = data7.map(x => <FilterItemValue>{ value: x.Id, label: x.Name }).sort((a, b) => a.label > b.label ? 1 : -1);
            me.filters.vintage.options = data8.map(x => <FilterItemValue>{ value: x, label: x }).sort((a, b) => a.label > b.label ? -1 : 1);

            me.processing = false;
        });
    }

    OpenFilters() {
        let me = this;
        me.IsFilterOpen = !me.IsFilterOpen;
    }

    Clear() {
        let me = this;
        me.cleared.emit();
        me.LoadData(); // load data again
    }

    SaveFilter() {
        // console.log('SaveFilter');
        let me = this;
    }

    Updated(src) {
        let me = this;

        // check dependancies
        me.FilterFilters(src);

        me.updated.emit();
        me.stateService.loginKeepAlive();
    }

    FilterFilters(src) {
        let me = this;
        // first time dependant filter execution
        if (!me.filters.category.values.length && !me.filters.country.values.length && !me.filters.region.values.length && !me.filters.winery.values.length) {
            me.firstSelected = src;
        }

        let wines = me.allWines;
        if (me.filters.category.values.length) {
            wines = wines.filter(o => me.filters.category.values.filter(j => j.value == o.WineCategoryId).length);
        }
        if (me.filters.region.values.length) {
            wines = wines.filter(o => me.filters.region.values.filter(j => j.value == o.RegionId).length);
        }
        if (me.filters.winery.values.length) {
            wines = wines.filter(o => me.filters.winery.values.filter(j => j.value == o.WineryId).length);
        }
        if (me.filters.variety.values.length) {
            wines = wines.filter(o => me.filters.variety.values.filter(j => j.value == o.VarietyId).length);
        }

        let wineries = me.allWineries.filter(o => wines.filter(j => j.WineryId == o.Id).length);
        if (me.filters.country.values.length) {
            wineries = wineries.filter(o => me.filters.country.values.filter(j => j.value == o.CountryId).length);
        }

        //Categories
        if (me.filters.category.values.length) {
            me.filters.category.options = me.filters.category.options.filter(o => me.filters.category.values.filter(j => j.value == o.value).length);
        } else {
            // Apply other filters
            me.filters.category.options = me.allCategories.filter(o => wines.filter(j => j.WineCategoryId == o.Id).length).map(x => <FilterItemValue>{ value: x.Id, label: x.Name }).sort((a, b) => a.label > b.label ? 1 : -1);
        }

        //Countries
        if (me.filters.country.values.length) {
            me.filters.country.options = me.filters.country.options.filter(o => me.filters.country.values.filter(j => j.value == o.value).length);
        } else {
            // Apply other filters
            me.filters.country.options = me.allCountries.filter(o => wineries.filter(j => j.CountryId == o.Id).length).map(x => <FilterItemValue>{ value: x.Id, label: x.Name }).sort((a, b) => a.label > b.label ? 1 : -1);
        }

        //Regions
        if (me.filters.region.values.length) {
            me.filters.region.options = me.filters.region.options.filter(o => me.filters.region.values.filter(j => j.value == o.value).length);
        } else {
            // Apply other filters
            me.filters.region.options = me.allRegions.filter(o => wines.filter(j => j.RegionId == o.Id).length).map(x => <FilterItemValue>{ value: x.Id, label: x.Name }).sort((a, b) => a.label > b.label ? 1 : -1);
        }

        //Varieties
        if (me.filters.variety.values.length) {
            me.filters.variety.options = me.filters.variety.options.filter(o => me.filters.variety.values.filter(j => j.value == o.value).length);
        } else {
            // Apply other filters
            me.filters.variety.options = me.allVarieties.filter(o => wines.filter(j => j.VarietyId == o.Id).length).map(x => <FilterItemValue>{ value: x.Id, label: x.Name }).sort((a, b) => a.label > b.label ? 1 : -1);
        }

        //Wineries
        if (me.filters.winery.values.length) {
            me.filters.winery.options = me.filters.winery.options.filter(o => me.filters.winery.values.filter(j => j.value == o.value).length);
        } else {
            // Apply other filters
            me.filters.winery.options = wineries.map(x => <FilterItemValue>{ value: x.Id, label: x.Name }).sort((a, b) => a.label > b.label ? 1 : -1);
        }


    }

    RegionUpdated(src) {
        let me = this;
        // For Regions, use the parent (data) value to add the appropriate Countries to the filter
        // this.filters.region.values.forEach(element => {
        //     if (element.data) {
        //         var countryOption = me.filters.country.options.find(x => x.value == element.data);
        //         if (me.filters.country.values.findIndex(x => x.value == countryOption.value) <= -1) {
        //             me.filters.country.values.push(countryOption);
        //         }
        //     }
        // });
        me.Updated(src);       // Done.
    }

    WineryUpdated() {
        let me = this;
        // For Wineries, use the parent (data) value to add the appropriate Region to the filter
        // this.filters.winery.values.forEach(element => {
        //     if (element.data) {
        //         var regionOption = me.filters.region.options.find(x => x.value == element.data);
        //         if (me.filters.region.values.findIndex(x => x.value == regionOption.value) <= -1) {
        //             me.filters.region.values.push(regionOption);
        //         }
        //     }
        // });
        me.RegionUpdated('winery'); // Now check regions
    }

    StripFilters(originalFilters: AuctionLotSearchFilters) {
        var filters = <AuctionLotSearchFilters>{};
        if (originalFilters.category) filters.category = { values: originalFilters.category.values };
        if (originalFilters.country) filters.country = { values: originalFilters.country.values };
        if (originalFilters.excludeAttribute) filters.excludeAttribute = { values: originalFilters.excludeAttribute.values };
        if (originalFilters.keyword) filters.keyword = { value: originalFilters.keyword.value };
        if (originalFilters.lotNumber) filters.lotNumber = { value: originalFilters.lotNumber.value };
        if (originalFilters.price) {
            filters.price = {
                value: originalFilters.price.value,
                minValue: originalFilters.price.minValue,
                maxValue: originalFilters.price.maxValue,
            };
        }
        if (originalFilters.region) filters.region = { values: originalFilters.region.values };
        if (originalFilters.unitOfMeasure) filters.unitOfMeasure = { values: originalFilters.unitOfMeasure.values };
        if (originalFilters.variety) filters.variety = { values: originalFilters.variety.values };
        if (originalFilters.vintage) filters.vintage = { values: originalFilters.vintage.values };
        if (originalFilters.winery) filters.winery = { values: originalFilters.winery.values };
        return filters;
    }

    MergeValues(originalFilters: AuctionLotSearchFilters, toMerge: AuctionLotSearchFilters) {
        var filters = <AuctionLotSearchFilters>{ ...originalFilters };
        if (toMerge.category) filters.category.values = toMerge.category.values;
        if (toMerge.country) filters.country.values = toMerge.country.values;
        if (toMerge.excludeAttribute) filters.excludeAttribute.values = toMerge.excludeAttribute.values;
        if (toMerge.keyword) filters.keyword.value = toMerge.keyword.value;
        if (toMerge.lotNumber) filters.lotNumber.value = toMerge.lotNumber.value;
        if (toMerge.region) filters.region.values = toMerge.region.values;
        if (toMerge.price) {
            filters.price.value = toMerge.price.value;
            filters.price.minValue = toMerge.price.minValue;
            filters.price.maxValue = toMerge.price.maxValue;
        }
        if (toMerge.region) filters.region.values = toMerge.region.values;
        if (toMerge.unitOfMeasure) filters.unitOfMeasure.values = toMerge.unitOfMeasure.values;
        if (toMerge.variety) filters.variety.values = toMerge.variety.values;
        if (toMerge.vintage) filters.vintage.values = toMerge.vintage.values;
        if (toMerge.winery) filters.winery.values = toMerge.winery.values;
        return filters;
    }

    CreateCustomFilter() {
        let me = this;
        const modalRef = me.modalService.open(ModalCreateCustomFilterComponent, {
            scrollable: true,
            size: 'lg'
        });
        modalRef.componentInstance.model = { ...this.model }; // clone model
        modalRef.componentInstance.apply.subscribe(($e) => {
            if ($e) {
                me.customFilterService.Create($e, JSON.stringify(me.StripFilters(me.filters))).subscribe(data => {
                    // console.log('CustomFilter.Create', data);
                    me.customFilters.push(data);
                })
            }
        });
    }
    ApplyCustomFilter(item: CustomFilterModel) {
        // console.log('ApplyCustomFilter', item);
        let me = this;
        let deserializedFilter = JSON.parse(item.SerializedFilter);
        let mergedFilter = me.MergeValues(me.filters, deserializedFilter);
        // console.log('Post merge', mergedFilter, me.filters, deserializedFilter);
        me.filters = mergedFilter;

        me.Updated('custom');
    }
    DeleteCustomFilter(item: CustomFilterModel) {
        // console.log('DeleteCustomFilter', item);
        let me = this;
        me.customFilterService.Delete(item.Id).subscribe(data => {
            // console.log('CustomFilter.Delete', data);
            me.customFilters.splice(me.customFilters.indexOf(item), 1);
        })
    }
}
